import { render, staticRenderFns } from "./ContractSummary.vue?vue&type=template&id=6179161b"
import script from "./ContractSummary.vue?vue&type=script&lang=js"
export * from "./ContractSummary.vue?vue&type=script&lang=js"
import style0 from "./ContractSummary.vue?vue&type=style&index=0&id=6179161b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports